import { ThemeProvider } from "@mui/material/styles";
import { Mapping } from "@platformx/prelems";
import { PrelemComponentContainer } from "@platformx/site-page";
import { PrelemTheme, ThemeConstantForPrelemThemeBasedOnSite } from "@platformx/themes";
import { lazy, memo } from "react";

//Prelem props
const prelemAnalyticsProp = {};
const prelemAuthoringHelperProp = {
  isEditPage: false,
  isEditing: false,
  authoringHoverShow: false,
};

const siteTheme = localStorage.getItem("siteTheme");
const ThemeConstant = ThemeConstantForPrelemThemeBasedOnSite(siteTheme);

//mapping dynamic instance
const mappingDynamicInstance = {};
Object.keys(Mapping).forEach((item) => {
  mappingDynamicInstance[item] = lazy(() =>
    import(`@platformx/prelems`).then((module) => ({
      default: module[Mapping[item]],
    })),
  );
  return mappingDynamicInstance;
});

const PrelemsListContainer = ({ prelemContent, PrelemId }) => {
  const secondaryArgs = {
    prelemBaseEndpoint: {
      APIEndPoint: "https://dev.api.hcl-x.com/platform-x/",
      PublishEndPoint: "https://kiwi.hcl-x.com/",
      device: "window",
      buttonBaseUrl: "https://kiwi.hcl-x.com/",
      language: "en",
      deliveryEndPointGq: "https://dev.api-publish.hcl-x.com/platform-x-publish/v1/publish/gateway",
      isRendering: false,
      captchaGoogleSiteKey: "6LeaWTMrAAAAAO0-vjKmI8mZ5QZR9w9v_-L-je7r",
      environment: "local",
      enableCaptcha: "true",
    },
    editState: false,
    currentPageURL: "prelem-vv-1771934286536",
    multiSlot: {},
    gcpUrl: "https://cropped-image.hcl-x.com",
    sitename: "kiwi",
    isEditorJSEnable: false,
  };

  const PrelemComponent = mappingDynamicInstance?.[PrelemId];
  return (
    <ThemeProvider theme={() => PrelemTheme(ThemeConstant)}>
      {PrelemComponent ? (
        <PrelemComponentContainer
          prelemComponent={PrelemComponent}
          content={prelemContent}
          analytics={prelemAnalyticsProp}
          authoringHelper={prelemAuthoringHelperProp}
          secondaryArgs={secondaryArgs}
          prelemId={PrelemId}
        />
      ) : null}
    </ThemeProvider>
  );
};

export default memo(PrelemsListContainer);
